import { sendAnalyticEvent } from '@app/web-analytic';

import {
  type AnalyticEvent,
  REQUEST_ERROR_TYPE_ANALYTIC_EVENT,
} from '../constants';
import type { Mismatch } from '../types/common-response';

export const sendRequestErrorsAnalytics = (
  analyticEvent: AnalyticEvent,
  mismatches?: Mismatch[]
) =>
  sendAnalyticEvent(analyticEvent, {
    type: REQUEST_ERROR_TYPE_ANALYTIC_EVENT,
    description: mismatches?.map(({ message }) => message)?.join('. '),
  });
